angular.module('zc.core')

.directive 'zcDateTimePicker', ($filter) ->
  restrict: 'E'
  scope:
    pickerId: '@'
    data: '=?ngModel'
    isRequired: '=?'
    minView: '@'
  templateUrl: '/templates/core/views/directives/zc_date_time_picker.html'



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/zc_date_time_picker.js.coffee